import React from 'react';
import PropTypes from 'prop-types';
import {
  FormFieldSpinnerUp,
  FormFieldSpinnerDown,
} from '@wix/wix-ui-icons-common/system';

import { st, classes } from './Ticker.st.css';
import InputConsumer from '../InputConsumer';
import { dataHooks } from './Ticker.constants';

type Props = {
  onUp?: React.MouseEventHandler<HTMLElement>;
  onDown?: React.MouseEventHandler<HTMLElement>;
  upDisabled?: boolean;
  downDisabled?: boolean;
  onMouseDown?: React.MouseEventHandler<HTMLElement>;
  dataHook?: string;
};

const Ticker = ({
  onUp,
  onDown,
  upDisabled,
  downDisabled,
  onMouseDown,
  dataHook,
}: Props) => (
  <InputConsumer consumerCompName={Ticker.displayName}>
    {({ disabled, readOnly, size }) => {
      const isUpDisabled = upDisabled || disabled || readOnly;
      const isDownDisabled = downDisabled || disabled || readOnly;
      return (
        <div
          className={st(classes.root, {
            size,
          })}
          onMouseDown={onMouseDown}
          data-hook={dataHook}
        >
          <div
            data-hook={dataHooks.tickerUp}
            data-disabled={isUpDisabled}
            className={st(classes.up, { disabled: isUpDisabled })}
            onClick={isUpDisabled ? undefined : onUp}
          >
            <FormFieldSpinnerUp />
          </div>
          <div
            data-hook={dataHooks.tickerDown}
            data-disabled={isDownDisabled}
            className={st(classes.down, { disabled: isDownDisabled })}
            onClick={isDownDisabled ? undefined : onDown}
          >
            <FormFieldSpinnerDown />
          </div>
        </div>
      );
    }}
  </InputConsumer>
);

Ticker.displayName = 'Input.Ticker';

Ticker.propTypes = {
  onUp: PropTypes.func,
  onDown: PropTypes.func,
  upDisabled: PropTypes.bool,
  downDisabled: PropTypes.bool,
  onMouseDown: PropTypes.func,
  dataHook: PropTypes.string,
};

export default Ticker;
